// extracted by mini-css-extract-plugin
export var avatar = "OutcomeIcon-module--avatar--b6095";
export var icon = "OutcomeIcon-module--icon--32e85";
export var outcomeIcon = "OutcomeIcon-module--outcomeIcon--0e604";
export var silkSpacing = "OutcomeIcon-module--silkSpacing--6c1e8";